import { Injectable } from "@angular/core";
import { LoginApiServices } from "../_services/login-api.services";
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
import { User } from './../_models/sesion/user';

@Injectable({
    providedIn: 'root'
})
export class LoginManager {

    private _loading: BehaviorSubject<any> = new BehaviorSubject(false);
    private _pass: BehaviorSubject<any> = new BehaviorSubject(null);
    private _usuario: BehaviorSubject<any> = new BehaviorSubject(null);
    private currentUserSubject: BehaviorSubject<any>;
    public currentUser: Observable<User>;
    public _list:BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(
        private LoginService: LoginApiServices,
        private router: Router,
        private snackBar: MatSnackBar
    ) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    getLoading() {
        return this._loading.asObservable();
    }

    getLUsuario() {
        return this._usuario.asObservable();
    }


    Logout() {
        this.deleteToken();
        this.router.navigate(['/login'])
    }

    Login(User, Password) {
        this._loading.next(true);
        return this.LoginService.Loging(User, Password).pipe(map((user: User) => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(user);
            if (this.currentUserSubject.getValue().error && this.currentUserSubject.getValue().error !== 6) {
                this.snackBar.open(this.currentUserSubject.getValue().message, null, {
                    duration: 3000
                });
            } else if(this.currentUserSubject.getValue().error === 6){
                this.snackBar.open(this.currentUserSubject.getValue().message, null, {
                    duration: 3000
                });
                this.router.navigate(['/key-change', this.currentUserSubject.getValue().usuario]);
            }
            return user;
        }, err => {
            this._loading.next(false);
            this.snackBar.open('Error', null, {
                duration: 3000
            });

        }));
    }

    getToken() {
        let session = JSON.parse(localStorage.getItem("currentUser"))
        return session ? session.jwt : "";
    }

    deleteToken() {
        let session = JSON.parse(localStorage.getItem("currentUser"))
        session && localStorage.removeItem("currentUser")
        this.currentUserSubject.next(null);
    }

    isLogin() {
        //return JSON.parse(localStorage.getItem("currentUser"))?true:false;
        return this.currentUserSubject.value;
    }
    getListToken() {
        return this._list.asObservable();
    }


    isToken() {
        this.LoginService.isToken().subscribe(rest => {
            this._loading.next(false)
            this._list.next(rest);
        }, err => {
            this._loading.next(false)
        })
    }

    keyChange(password, passwordnew, passwordconf) {
        this._loading.next(true);
        let variable = JSON.parse(localStorage.getItem("currentUser"));
        let postdata = { codinter: variable.codinter, passant: password, pass: passwordnew, passr: passwordconf };
        this.LoginService.password(postdata).subscribe(rest => {
            this._loading.next(false);
            this._pass.next(rest);
            if (this._pass.getValue().exito) {
                this.snackBar.open('Cambio de contraseña exitoso ', null, {
                    duration: 3000
                });
            } else {
                this.snackBar.open(this._pass.getValue().message, null, {
                    duration: 3000
                });
            }
        }, err => {
            this._loading.next(false);

        });
    }

    keyChangeSinLogin(codinter, password, passwordnew, passwordconf) {
        this._loading.next(true);
        const postdata = { codinter: codinter, passant: password, pass: passwordnew, passr: passwordconf };
        this.LoginService.password(postdata).subscribe(rest => {
            this._loading.next(false);
            this._pass.next(rest);
            if (this._pass.getValue().exito) {
                this.snackBar.open('Contraseña renovada', null, {
                    duration: 3000
                });
                this.router.navigate(['/login']);
            } else {
                this.snackBar.open(this._pass.getValue().message, null, {
                    duration: 3000
                });
            }
        }, err => {
            this._loading.next(false);
    
        });
    }    
    keyChangeOlvidoC(codinter, passwordnew, passwordconf) {
        this._loading.next(true);
        const postdata = { codinter: codinter, passant: '', pass: passwordnew, passr: passwordconf };
        this.LoginService.passwordC(postdata).subscribe(rest => {
            this._loading.next(false);
            this._pass.next(rest);
            if (this._pass.getValue().exito) {
                this.snackBar.open('Contraseña recuperada', null, {
                    duration: 3000
                });
                this.router.navigate(['/login']);
            } else {
                this.snackBar.open(this._pass.getValue().message, null, {
                    duration: 3000
                });
            }
        }, err => {
            this._loading.next(false);
    
        });
    } 

    getUsuario(){
        this._loading.next(true);
        this.LoginService.getUsuario().subscribe(rest => {
            this._loading.next(false);
            this._usuario.next(rest);
        }, err => {
            this._loading.next(false);
        });
    }


}
